export default __webpack_public_path__ + "static/media/suyog.c969dd00.jpg";